import Request from './request';
import { TOPIC_CHAPTER } from './utilityFunctions';

const chapterForController = {
  academy: TOPIC_CHAPTER.ACADEMY,
  certificate: TOPIC_CHAPTER.PERFORM,
  challenges: TOPIC_CHAPTER.PERFORM,
  dashboard: TOPIC_CHAPTER.WALL,
  journey: TOPIC_CHAPTER.PERFORM,
  profile: TOPIC_CHAPTER.WHOSWHO,
  rewards: TOPIC_CHAPTER.PERFORM,
  survey: TOPIC_CHAPTER.WALL,
};

const fetchTopic = chapter =>
  new Promise(resolve => {
    new Request()
      .get('/topic-message/highlights', { chapter }, true, false)
      .done(({ data }) => {
        if (!data.visible || !data.topics || !data.topics.length > 0) {
          resolve();
        }
        resolve(data.topics[0]);
      });
  });

const fetchBannerAndStats = () =>
  new Promise(resolve => {
    const segmentRegex = /(?:\/[a-z]{2})?\/([^/]+)/;
    const match = segmentRegex.exec(window.location.pathname);
    if (!match || match.length < 2) resolve();
    const chapter = chapterForController[match[1]];
    if (!chapter) resolve({ message: null, stats: null });

    Promise.all([fetchTopic(chapter)]).then(([message]) =>
      resolve({ message }),
    );
  });

export default fetchBannerAndStats;
